import { render } from "./SkeletonLoader.ce.vue?vue&type=template&id=241653ec"
import script from "./SkeletonLoader.ce.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader.ce.vue?vue&type=script&lang=js"

import _style_0 from "./SkeletonLoader.ce.vue?vue&type=style&index=0&id=241653ec&inline&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__